/**
 * CookieManager
 * Utility for checking cookie presence
 *
 * Note: The refresh token cookie is httpOnly and set by the backend,
 * so we cannot read or write it from JavaScript. We can only check
 * if cookies are enabled and will be sent automatically by the browser.
 */
export class CookieManager {
  /**
   * Check if cookies are enabled in the browser
   */
  public static areCookiesEnabled(): boolean {
    try {
      document.cookie = 'cookietest=1';
      const cookiesEnabled = document.cookie.indexOf('cookietest=') !== -1;
      document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
      return cookiesEnabled;
    } catch (_) {
      return false;
    }
  }

  /**
   * Check if a specific cookie exists (only works for non-httpOnly cookies)
   */
  public static hasCookie(name: string): boolean {
    return document.cookie.split(';').some((cookie) => {
      return cookie.trim().startsWith(`${name}=`);
    });
  }

  /**
   * Get cookie value (only works for non-httpOnly cookies)
   */
  public static getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  /**
   * Delete a cookie by name (only works for non-httpOnly cookies)
   */
  public static deleteCookie(name: string): void {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  }
}
